import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        banner: {
            backgroundColor: 'background.light',
            borderTop: 'small',
            borderColor: 'border.secondary',
            pos: 'fixed',
            bottom: '0',
            left: '0',
            w: '100%',
            zIndex: '999',
        },
        bannerHeader: {
            justify: 'center',
            align: 'center',
            gap: remCalc(8),
            p: remCalc(24),
            cursor: 'pointer',
        },
        bannerHeaderLabel: {textAlign: 'center', fontWeight: 'bold', textStyle: 'head-xsmall'},
        bannerHeaderButton: {
            minWidth: 'auto',
            height: 'auto',
            padding: 0,
        },
        bannerBody: {
            layerStyle: 'page',
            columns: {base: 1, lg: 4},
            gap: {base: remCalc(14), lg: remCalc(24)},
            px: {base: remCalc(16), lg: 0},
            m: 'auto',
            mb: remCalc(24),
        },
        bannerButtonGroup: {columns: 1, gap: remCalc(24), w: '100%', m: 'auto'},
        bannerSelectMore: {
            textAlign: 'center',
            textStyle: 'body-xsmall',
            color: 'text.secondary',
        },
        bannerRemoveItems: {fontWeight: 'medium'},
        productSelectionContainer: {
            backgroundColor: 'white',
            h: {base: remCalc(85), lg: remCalc(138)},
            align: 'center',
            gap: remCalc(12),
            px: {base: remCalc(10), lg: remCalc(19)},
            py: {base: remCalc(13), lg: remCalc(13)},
            justify: 'space-between',
            position: 'relative',
        },
        productSelectionSubContainer: {
            gap: {base: remCalc(24), lg: remCalc(9)},
            align: 'center',
        },
        productSelectionImage: {w: {base: remCalc(85), lg: remCalc(111)}, ratio: 1},
        productSelectionName: {
            textStyle: 'body-small',
            fontWeight: {base: 'bold', lg: 'normal'},
            mb: remCalc(13),
        },
        productSelectionId: {
            textStyle: {base: 'body-xsmall', lg: 'body-small'},
            color: 'text.secondary',
        },
        productSelectionClose: {
            position: {base: 'block', lg: 'absolute'},
            top: remCalc(10),
            right: remCalc(10),
            boxSize: 'iconsSize.small',
            minWidth: 'auto',
            height: 'auto',
            padding: 0,
        },
        productSelectionEmptyContainer: {
            h: {base: remCalc(85), lg: remCalc(138)},
            backgroundColor: 'white',
            border: 'small',
            borderColor: 'border.light',
            borderStyle: 'dashed',
            justify: 'center',
            align: 'center',
            color: 'text.secondary',
        },
        modal: {
            layerStyle: 'page',
            position: 'relative',
            paddingX: {base: remCalc(16), lg: remCalc(24)},
        },
        modalBody: {
            gap: {base: remCalc(13), lg: remCalc(40)},
        },
        modalClose: {
            top: '50%',
            right: 0,
            transform: 'translateY(-50%)',
        },
        modalCloseIcon: {boxSize: {base: 'iconsSize.medium'}},
        modalTiles: {gap: remCalc(40), mt: {base: remCalc(24), lg: remCalc(40)}},
        modalTilesLabel: {
            textStyle: 'head-xsmall',
            fontWeight: 'bold',
            color: 'text.default',
            textAlign: 'center',
        },
        tileGrid: {
            gap: {
                base: remCalc(8),
                md: remCalc(24),
            },
            w: 'fit-content',
            m: 'auto',
            alignItems: 'self-start',
        },
        tileCard: {
            pos: 'relative',
            gap: {base: remCalc(8), lg: remCalc(16)},
            w: {base: remCalc(85), sm: remCalc(109), lg: remCalc(214)},
            display: 'flex',
            flexDirection: 'column',
        },
        tileImage: {w: {base: remCalc(95), lg: remCalc(160)}, ratio: 1, m: 'auto'},
        tileBody: {gap: remCalc(12), textStyle: 'body-small'},
        tileProductName: {
            noOfLines: 2,
            textStyle: 'head-xsmall',
            fontWeight: 'medium',
            height: remCalc(40),
        },
        tilePrice: {
            height: 'auto',
            wordBreak: 'break-word',
            whiteSpace: {
                base: 'nowrap',
                lg: 'normal',
            },
            overflow: {
                base: 'hidden',
                lg: 'visible',
            },
            textOverflow: {
                base: 'ellipsis',
                lg: 'clip',
            },
        },
        energyLabelStyle: {
            textStyle: 'body-xsmall',
            width: {
                base: remCalc(60),
                md: 'auto',
            },
        },
        tileProductId: {
            color: 'text.secondary',
            textStyle: 'body-small',
            wordBreak: 'break-word',
            whiteSpace: {
                base: 'nowrap',
                lg: 'normal',
            },
            overflow: {
                base: 'hidden',
                lg: 'visible',
            },
            textOverflow: {
                base: 'ellipsis',
                lg: 'clip',
            },
        },
        listPriceProps: {
            textStyle: 'body-small',
            color: 'text.secondary',
        },
        currentPriceProps: {
            color: 'text.default',
            textStyle: 'body-large',
            fontWeight: 'normal',
        },
        tileDiscoverButton: {
            variant: 'primary',
            w: '100%',
            paddingX: remCalc(16),
            paddingY: remCalc(8),
            textStyle: 'body-xsmall',
        },
        closeGroup: {justify: 'flex-end', gap: remCalc(4), align: 'center'},
        closeMessage: {textStyle: 'body-small', color: 'text.default'},
        compareTableHeader: {
            justify: 'space-between',
            background: 'background.light',
            align: 'center',
            w: '100%',
            paddingTop: 'small.base',
            paddingBottom: 'small.base',
            paddingX: {base: remCalc(16), lg: remCalc(24)},
            border: 'small',
            borderStyle: 'solid',
            borderColor: 'border.table',
            cursor: 'pointer',
        },
        compareTableHeaderLabel: {textAlign: 'center', textStyle: 'body-small'},
        compareTableGrid: {gap: remCalc(24)},
        reviewsContainer: {
            display: {base: 'none', lg: 'block'},
        },
        modalTilesHeader: {
            position: 'relative',
            justifyContent: 'space-evenly',
        },
    },
}
